export default function PublicHeader() {
    return(
        <header className='sticky top-0 z-50 backdrop-blur-md bg-white/70 border-b border-white/30'>
            <div className='mx-auto max-w-6xl flex items-center justify-between px-6'>
                <a href='/' className='flex items-center py-4'>
                    <img src='/assets/invoco_logo_long_purple_transparentbg.webp' alt='invoco logo - Patient Ready, Practice Ready, get invoco' className='h-12 w-auto'/>
                    
                </a>

                <a href='/login' className='font-semibold text-slate-800 px-4 py-2 rounded-lg hover:bg-slate-100/60 transition'>
                    Sign In
                </a>
            </div>
        </header>
    )
}